'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  return typeof value === 'string';
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/isString.js
// module id = 1000
// module chunks = 0